<div
  class="header"
  ngClass.lt-md="mobile"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  fxLayoutGap="50px"
  fxLayoutGap.lt-md="20px"
>
  <div class="headline-container" fxFlex="grow">
    <span class="headline-h3" ngClass.lt-md="mobile">
      {{ courseTitle?.toUpperCase() || '' }}
    </span>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="flex-end center"
    fxLayoutGap="16px"
    fxFlex="grow"
    fxFlex.lt-md="0"
  >
    <div>
      <div
        class="more-options"
        ngClass.lt-md="mobile"
        [matMenuTriggerFor]="optionsMenu"
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        fxLayoutGap.lt-md="0px"
      >
        <button mat-icon-button class="more-options-button">
          <mat-icon aria-hidden="true">more_horiz</mat-icon>
        </button>
      </div>
      <mat-menu #optionsMenu="matMenu" class="actions-popover h5p-player-header-popover">
        <button mat-menu-item [routerLink]="'/courses/' + courseId + '/overview'" [queryParams]="getQueryParams()">
          <mat-icon>exit_to_app</mat-icon>
          <a>{{ 'courses.leave' | translate }}</a>
        </button>
        <button mat-menu-item (click)="openUserback()">
          <mat-icon>feedback</mat-icon>
          <a>{{ 'main.header.feedback' | translate }}</a>
        </button>
      </mat-menu>
    </div>
    @if (isSkippable) {
      <button
        ngClass.lt-md="hide"
        mat-stroked-button
        color="darkblue"
        (click)="onSkip()"
      >
        {{ 'courses.activity.skip' | translate }}
      </button>
    }
    <button
      ngClass.lt-md="hide"
      [disabled]="!hasPrevious"
      mat-stroked-button
      color="darkblue"
      (click)="onPrevious()"
      [ngClass]="{ 'visibility-hidden': !showCourseNavigation }"
    >
      {{ 'common.previous' | translate }}
    </button>
    <button
      ngClass.lt-md="hide"
      [disabled]="!hasNext"
      class="filled no-border"
      mat-stroked-button
      color="yellow"
      (click)="onNext()"
      [ngClass]="{ 'visibility-hidden': !showCourseNavigation }"
    >
      {{ (isLastActivity ? 'common.complete' : 'common.next') | translate }}
    </button>
  </div>
</div>
